import catalogData from "./data.json";

function userOptionKindNameKey(kind: unknown, name: unknown): string {
  return JSON.stringify([
    typeof kind === "string" ? kind : "",
    typeof name === "string" ? name : "",
  ]);
}

function buildCatalogApplyFoamCutoutsIndex(): Map<string, boolean> {
  const index = new Map<string, boolean>();
  for (const option of catalogData) {
    if (
      !Array.isArray(option.cutouts) ||
      option.cutouts.length === 0 ||
      typeof option.kind !== "string" ||
      typeof option.name !== "string"
    ) {
      continue;
    }
    index.set(
      userOptionKindNameKey(option.kind, option.name),
      option.applyFoamCutouts === true,
    );
  }
  return index;
}

const catalogApplyFoamCutoutsIndex = buildCatalogApplyFoamCutoutsIndex();

export function hasNonEmptyCutouts(data: Record<string, unknown>): boolean {
  return Array.isArray(data.cutouts) && data.cutouts.length > 0;
}

export function resolveApplyFoamCutoutsFromCatalog(
  data: Record<string, unknown>,
): boolean {
  const key = userOptionKindNameKey(data.kind, data.name);
  return catalogApplyFoamCutoutsIndex.get(key) === true;
}

/**
 * Ensures supply-part options with cutouts always carry an explicit applyFoamCutouts flag.
 */
export function normalizeApplyFoamCutoutsForImport(
  data: Record<string, unknown>,
): Record<string, unknown> {
  if (hasNonEmptyCutouts(data)) {
    if (typeof data.applyFoamCutouts === "boolean") {
      return data;
    }

    return {
      ...data,
      applyFoamCutouts: resolveApplyFoamCutoutsFromCatalog(data),
    };
  }

  return data;
}
